import type {ILogin, ILoginResponse, LoginMethod} from "@/model/yarismaci";
import ApiService, {type ApiError} from "./api";
import LogService, {LogIslem, LogSayfa} from "./log";
import {mapLoginToDTO} from "@/model/yarismaci.dto";
import JwtService from "./jwt";
import YarismaService from "./yarisma";
import {ErrorPopup} from "@/utils/popup";

export class YarismaciService {
  static async login(
    {method, email, phone, code, tc, dogum_gun, dogum_ay, dogum_yil}:
    {
      method?: LoginMethod,
      email?: string,
      phone?: string,
      code?: string,
      tc?: string,
      dogum_gun?: string,
      dogum_ay?: string,
      dogum_yil?: string
    }):
    Promise<ApiError> {
    const loginModel: ILogin = {
      method: method,
      client_id: LogService.getClientId(),
      session_id: LogService.getSessionId(),
      client_time: new Date(),
      email: email,
      phone: phone,
      code: code,
      tc: tc,
      dogum_gun: dogum_gun,
      dogum_ay: dogum_ay,
      dogum_yil: dogum_yil,
    }

    const payload = mapLoginToDTO(loginModel);
    const [err, resp] = await ApiService.post<ILoginResponse>('login', payload);
    if (err) {
      LogService.log(LogSayfa.GIRIS, LogIslem.HATA, {
        err,
        payload,
      });
      return err;
    }
    JwtService.saveAccessTokens(resp!.data.token);
    return null;
  }

  static getYarismaciIsmi(): string {
    return JwtService.getTokenObj().isim as string;
  }

  static async yarismayiBaslat(): Promise<void> {
    if (YarismaService.getyarismaciBaslattiMi()) {
      return;
    }
    LogService.log(LogSayfa.YARISMA, LogIslem.YARISMA_BASLADI)
    const start = performance.now();
    const [err, resp] = await ApiService.post<void>('yarismaci/baslat', {ct: new Date()});
    if (err) {
      LogService.log(LogSayfa.YARISMA, LogIslem.HATA, {
        err,
        resp,
        delta: performance.now() - start
      });
      await ErrorPopup(err);
      return;
    }
    YarismaService.setyarismaciBaslattiMi(true);
  }

  static async yarismayiBitir(): Promise<boolean> {
    const start = performance.now();
    const [err, resp] = await ApiService.post<void>('yarismaci/bitir', {ct: new Date()});
    if (err) {
      LogService.log(LogSayfa.YARISMA, LogIslem.HATA, {
        err,
        resp,
        delta: performance.now() - start
      });
      await ErrorPopup(err);
      return false;
    }
    YarismaService.setyarismaciYarismayiBitirmisMi(true);
    YarismaService.clear()
    return true;
  }
}
